import {useTranslation} from 'react-i18next';

import {TextField, Typography, useTheme} from '@mui/material';

import OnboardingSection from '../OnboardingSection';

import AreasOfExpertise from './AreasOfExpertise';
import LeadershipExperience from './LeadershipExperience';
import {EmpionDatePicker} from '../../../../../components/EmpionDatePicker/EmpionDatePicker';
import {getFieldStyle} from '../../../../../layouts/theme/FieldStyles';

interface QualificationsProps {
  formik: any;
}

export default function Qualificaitons({formik}: QualificationsProps) {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <OnboardingSection title={t('applicantOnboarding.qualifications.leadershipExperience')}>
      <LeadershipExperience formik={formik} />
      <AreasOfExpertise formik={formik} />
      <Typography mb={4} mt={4} variant='h3'>
        {t('applicantOnboarding.dreamJobDescription.title')}
      </Typography>
      <TextField
        type='text'
        name='applicantOnboarding.dreamJobDescription'
        value={formik.values.applicantOnboarding.dreamJobDescription}
        fullWidth
        onChange={(e) => {
          formik.setFieldValue('applicantOnboarding.dreamJobDescription', e.target.value);
        }}
        sx={getFieldStyle(theme)}
      />
      <Typography mb={4} mt={4} variant='h3'>
        {t('applicantOnboarding.earliestStartDate.title')}
      </Typography>
      <EmpionDatePicker
        name='applicantOnboarding.jobSearchPreferences.earliestStartDate'
        setFieldValue={formik.setFieldValue}
        value='applicantOnboarding.jobSearchPreferences.earliestStartDate'
        label={t('applicantOnboarding.earliestStartDate.formLabels.startDate') || ''}
      />
    </OnboardingSection>
  );
}
